export const I18N_URL = 'https://lokalise.attensi.com/admin' // TODO: check admin namechange to manager
export const MANIFEST_URL = `${I18N_URL}/manifest.json`
